import React, { Component } from 'react';
import SubscriptionTruckIcon from '../../../../public/images/icons/subscription-icons-delivery.svg';
import SubscriptionManagementIcon from '../../../../public/images/icons/subscription-icons-deliverymanagement.svg';
import SubscriptionNoFeeIcon from '../../../../public/images/icons/subscription-icons-nomembershipfee.svg';
import {IconImage} from "../index";


class SubscribeAndSaveToolTip extends Component<Props> {
  constructor() {
    super();

    this.state = {
      isVisible: false
    };
  }

  hideToolTip = () => {
    this.setState({
      isVisible: false,
    });
  };

  toggleToolTip = () => {
    const { isVisible } = this.state;
    this.setState({
      isVisible: !isVisible
    });
  };

  render() {
    const { isVisible } = this.state;
    const {dataId} = this.props;

    return (
      <div className="u__inline-block subscription_toolTip">
        <span
          aria-hidden
          role="button"
          className="u__default-link"
          onClick={this.toggleToolTip}
          data-automation-id={`subscribeToolTip-${dataId}`}
        >
          Learn More
        </span>
        {isVisible && (
          <div className="hdReactTooltip grid">
            <button
              data-automation-id={`subscribeToolTip-${dataId}`}
              type="button"
              className="mw-icon-menu-close tooltip__content__btn--close"
              target="_blank"
              onClick={this.hideToolTip}
            />
            <div className="grid">
                <div className=" col__1-1 u--paddingNone body__m-bottom-small body__border-bottom--light">
                    <div className="subscriptionInfo col__1-1 col__4-12--xs col__4-12--sm u--paddingNone-horizontal">

                          <div className="col__3-12 col__12-12--xs col__12-12--sm">
                            <IconImage
                              imageSrc={SubscriptionTruckIcon}
                              imageAlt="account-svg"
                              imageWidth="100"
                              imageClass="u--margin-right truck-image"
                            />
                          </div>

                        <div className="col__9-12 col__12-12--xs col__12-12--sm">5% off subscription purchases plus free delivery</div>
                    </div>
                    <div className="subscriptionInfo col__1-1 col__4-12--xs col__4-12--sm u--paddingNone-horizontal">

                          <div className="col__3-12 col__12-12--xs col__12-12--sm ">
                            <IconImage
                              imageSrc={SubscriptionManagementIcon}
                              imageAlt="account-svg"
                              imageWidth="45"
                              imageClass="u--margin-right"
                            />
                          </div>

                        <div className="col__9-12 col__12-12--xs col__12-12--sm">Pause or cancel your subscription anytime online</div>
                    </div>
                    <div className="subscriptionInfo col__1-1 col__4-12--xs col__4-12--sm u--paddingNone-horizontal">

                           <div className="col__3-12 col__12-12--xs col__12-12--sm">
                             <IconImage
                               imageSrc={SubscriptionNoFeeIcon}
                               imageAlt="account-svg"
                               imageWidth="57"
                               imageClass="u--margin-right"
                             />
                           </div>

                        <div className=" u__bold col__9-12 col__12-12--xs col__12-12--sm">No club or membership fees required</div>
                     </div>
                </div>

            </div>
            <p className="col__1-1">Subscribe to this product today to receive free delivery directly to your doorstop at your convenience. Just select your preferred delivery frequency from the drop down menu and checkout to start your subscription.</p>

          </div>
        )}
      </div>
    );
  }
}

SubscribeAndSaveToolTip.defaultProps = {
};

export default SubscribeAndSaveToolTip;
